import { FC } from 'react';
import styled from 'styled-components';
import { intervalToDuration } from 'date-fns';
import { Stack, Typography } from '@mui/material';
import { ActionIconVideoCamera } from '@vs-online-only-app/ui';

const GradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(14, 14, 15, 0) 23.96%,
    rgba(14, 14, 15, 0.88) 100%
  );
  border-radius: inherit;
`;

const Container = styled(Stack)`
  position: absolute;
  left: ${({ theme }) => theme.spacing(1)};
  bottom: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(0.5)};
  align-items: center;
`;

type Props = {
  videoDuration: number;
};

export const VideoDuration: FC<Props> = ({ videoDuration }) => {
  const { minutes, seconds } = intervalToDuration({
    start: 0,
    end: videoDuration * 1000,
  });

  return (
    <>
      <GradientOverlay />
      <Container>
        <ActionIconVideoCamera />
        <Typography variant="caption" color="textSecondary">
          {`${minutes !== undefined && minutes < 10 ? '0' : ''}${minutes}`}:
          {`${seconds !== undefined && seconds < 10 ? '0' : ''}${seconds}`}
        </Typography>
      </Container>
    </>
  );
};
